import script from "./DSBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./DSBadge.vue?vue&type=script&setup=true&lang=ts"

import "./DSBadge.vue?vue&type=style&index=0&id=62d65306&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d65306"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QIcon});
